// src/lib/features.js
// Central feature → tier mapping
// To gate a feature: add it here, then use useFeatureFlag('feature_name')
// September: everyone is 'beta' so all gates pass
// Post-field-test: flip tiers to enforce real gates

const TIER_RANK = {
  free: 0,
  player_pro: 1,
  player_elite: 2,
  beta: 99,
  m55_staff: 100,
}

const ORG_TIER_RANK = {
  free: 0,
  event: 1,
  org: 2,
  beta: 99,
}

// Feature definitions
// required_tier: minimum user tier needed
// required_org_tier: minimum org tier needed (optional)
export const FEATURES = {
  // Player features
  persistent_history:     { required_tier: 'player_pro' },
  basic_armory:           { required_tier: 'player_pro' },
  full_armory:            { required_tier: 'player_elite' },
  career_stats:           { required_tier: 'player_pro' },

  // Org features
  create_event:           { required_org_tier: 'event' },
  org_management:         { required_org_tier: 'org' },
  advanced_bounties:      { required_org_tier: 'org' },

  // M55 admin features
  m55_admin_panel:        { required_tier: 'm55_staff' },
  platform_settings:      { required_tier: 'm55_staff' },
}

export function hasFeature(featureName, userTier, orgTier = null) {
  const feature = FEATURES[featureName]
  if (!feature) return false

  // beta and m55_staff pass all gates
  if (userTier === 'beta' || userTier === 'm55_staff') return true

  // Check user tier requirement
  if (feature.required_tier) {
    const required = TIER_RANK[feature.required_tier] ?? 0
    const actual = TIER_RANK[userTier] ?? 0
    if (actual < required) return false
  }

  // Check org tier requirement
  if (feature.required_org_tier && orgTier) {
    const required = ORG_TIER_RANK[feature.required_org_tier] ?? 0
    const actual = ORG_TIER_RANK[orgTier] ?? 0
    if (actual < required) return false
  }

  return true
}